import React, {
    useCallback,
    useEffect,
    useRef,
    useState,
    useMemo,
} from "react";
import style from "./AdminAddBulkStockNew.module.css";
import Select from "react-select";



export default function AddStockTopSection({ fields, handledropdown, inputselectchange, filteredSupplier, filteredlot, filteredsku, branchOption }) {
    const [previousFields, setPreviousFields] = useState([]);

    useEffect(() => {
        if (fields !== previousFields) {
            console.log('Fields have changed:', fields);
            setPreviousFields(fields); // Update previousFields to trigger re-render on change
        }
    }, [fields]); // Re-run when 'fields' prop changes



    const options = filteredSupplier.map(supplier => ({
        label: supplier.VendorName,  // Display the vendor name
        value: supplier.Id           // Use the Id as the value
    }));

    console.log('checking filteredsupplier ', fields);
    
    const lotoptions = filteredlot.map(lot => ({
        label: lot.LotNumber,  // Display the vendor name
        value: lot.LotNumber           // Use the Id as the value
    }));

    const skuoptions = filteredsku.map(supplier => ({
        label: supplier.StockKeepingUnit,  // Display the vendor name
        value: supplier.Id           // Use the Id as the value
    }));

    const typeoptions = [
        { label: "Labelled", value: "Labelled" },
        { label: "UnLabelled", value: "UnLabelled" }
    ];

    return (
        <div className={style.adminAddCategoryMainBox2inner2}>
        <div className={style.adminAddCategoryMainBox2fieldbox}>

            {fields
                .filter((field) => field.place === "top" &&
                    field.visibility !== "Hidden" &&
                    field.IsVisible !== "Hidden")
                .sort((a, b) => a.priority - b.priority)
                .map((field, index) => {
                    if (field.type === "dropdown") {
                        return (
                            <div
                                key={index}
                                className={style.adminAddCategoryMainBox2fields}
                            >
                                <label
                                    htmlFor=""
                                    className={
                                        style.adminAddCategoryMainBox2label
                                    }
                                >
                                    {field.label}
                                </label>
                                <select
                                    name=""
                                    className={
                                        style.adminAddCategoryMainBox2select
                                    }
                                    id=""
                                    value={
                                        field.value
                                    }
                                    onChange={(e) => {
                                        handledropdown(field.key, e, 'top')
                                    }}
                                >
                                    <option value="">Select</option>
                                    {field.key === "Branch" ? (
                                        branchOption.map((item) => (
                                            <option value={item.BranchName}>
                                                {item.BranchName}
                                            </option>
                                        ))
                                    ) : field.key === "StockType" ? (
                                        <>
                                            <option value="Labelled">Labelled</option>
                                            <option value="UnLabelled">
                                                UnLabelled
                                            </option>
                                        </>
                                    ) : null}
                                </select>
                            </div>
                        );
                    }
                    if (field.type === "inputselect") {
                        const selectedOption =
                            field.key === "VendorId"
                                ? options.find((option) => option.value === field.value)
                                : field.key === "LotNumber"
                                    ? lotoptions.find((option) => option.value === field.value)
                                    : field.key === "SKU"
                                        ? skuoptions.find((option) => option.value === field.value)
                                        : null;
                        return (
                            <div
                                key={index}
                                className={style.adminAddCategoryMainBox2fields}
                            >
                                <label
                                    htmlFor=""
                                    className={
                                        style.adminAddCategoryMainBox2label
                                    }
                                >
                                    {field.label}
                                </label>
                                <Select
                                    options={field.key === 'VendorId' ? options : field.key === 'LotNumber' ? lotoptions : field.key === 'SKU' ? skuoptions : null}
                                    value={selectedOption}
                                    onChange={(e) => inputselectchange(field.key, e, 'top')}
                                    isSearchable={true}
                                    placeholder={field.label}
                                    className={
                                        style.adminAddCategoryMainBox2select
                                    }
                                    style={{ border: '1px solid #ddd' }}
                                />
                            </div>
                        );
                    }
                    return null;
                })}



            {/* {fields
                .filter(
                    (field) =>
                        field.place === "top" &&
                        field.visibility !== "Hidden" &&
                        field.IsVisible !== "Hidden"
                )
                .sort((a, b) => a.priority - b.priority)
                .map((field, index) =>
                    field.type === "dropdown" ? (
                        <div
                            key={index}
                            className={style.adminAddCategoryMainBox2fields}
                        >
                            <label
                                htmlFor=""
                                className={
                                    style.adminAddCategoryMainBox2label
                                }
                            >
                                {field.label}
                            </label>
                            <select
                                ref={(ref) => {
                                    if (!focusableRefs.current.topSectionRefs)
                                        focusableRefs.current.topSectionRefs = [];
                                    focusableRefs.current.topSectionRefs[
                                        index
                                    ] = ref;
                                }}
                                name=""
                                className={
                                    style.adminAddCategoryMainBox2select
                                }
                                id=""
                                value={
                                    field.key === "Branch"
                                        ? Branch
                                        : field.key === "StockType"
                                            ? StockType
                                            : ""
                                }
                                onChange={(e) => {
                                    if (field.key === "Branch") {
                                        setBranch(e.target.value);
                                    } else if (field.key === "StockType") {
                                        setStockType(e.target.value);
                                    }
                                }}
                            >
                                <option value="">Select</option>
                                {field.key === "Branch" ? (
                                    branchOption.map((item) => (
                                        <option value={item.BranchName}>
                                            {item.BranchName}
                                        </option>
                                    ))
                                ) : field.key === "StockType" ? (
                                    <>
                                        <option value="Labelled">Labelled</option>
                                        <option value="UnLabelled">
                                            UnLabelled
                                        </option>
                                    </>
                                ) : null}
                            </select>
                        </div>
                    ) : field.type === "inputselect" ? (
                        <div
                            key={index}
                            className={style.adminAddCategoryMainBox2fields}
                        >
                            <label
                                htmlFor=""
                                className={
                                    style.adminAddCategoryMainBox2label
                                }
                            >
                                {field.label}
                            </label>
                            <input
                                style={{ border: '1px solid #ddd' }}
                                list={field.key}
                                className={
                                    style.adminAddCategoryMainBox2input
                                }
                                ref={(ref) => {
                                    if (!focusableRefs.current.topSectionRefs)
                                        focusableRefs.current.topSectionRefs = [];
                                    focusableRefs.current.topSectionRefs[
                                        index
                                    ] = ref;
                                }}
                                onInput={handleInputChange} // Allow typing
                                onBlur={(e) =>
                                    validateinput(e, field.key, "top")
                                } // Validate on blur
                            // value={Supplier}
                            />
                            {field.key === "VendorId" ? (
                                <datalist id="VendorId">
                                    {filteredSupplier.map((x, y) => (
                                        <option key={y} value={x.VendorName}>
                                            {x.Id}
                                        </option>
                                    ))}
                                </datalist>
                            ) : field.key === "SKU" ? (
                                <datalist id="SKU">
                                    {filteredsku.map((sku, index) => (
                                        <option
                                            key={index}
                                            value={`${sku.StockKeepingUnit}`}
                                            vendor={sku.SKUId}
                                        />
                                    ))}
                                </datalist>
                            ) : field.key === "LotNumber" ? (
                                <datalist id="LotNumber">
                                    {filteredlot.map((x, index) => (
                                        <option key={index} value={x.LotNumber} />
                                    ))}
                                </datalist>
                            ) : null}
                        </div>
                    ) : null
                )} */}

        </div>
        </div>
    )


}